import React from "react";
import moment from "moment";

import ManageButtonGroup from "./ManageButtonGroup";

const ArtifactList = ({ artifacts, deleteArtifact }) => {
  return (
    <table className="table table-condensed table-hover">
      <thead>
        <tr>
          <th>Title</th>
          <th>Type</th>
          <th>Last Modified</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {artifacts.map(a => {
          return (
            <tr key={a.art_id}>
              <td>{a.art_title}</td>
              <td>{a.typ_name}</td>
              <td>{moment(a.art_updated_at).format("MM-DD-YYYY")}</td>
              <td>
                <span className="pull-right">
                  <ManageButtonGroup
                    artifactID={a.art_id}
                    deleteArtifact={deleteArtifact}
                  />
                </span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ArtifactList;



// WEBPACK FOOTER //
// ./src/pages/Artifacts/ArtifactList.jsx